<script>
export default {
  functional: true,
  name: "InnerSelect",
  render: function (h, { props, parent, children, listeners, ...args }) {
    const { name, enumValues, value, multiple, collapseTags, showLabel } = props;
    const change = listeners.change;
    return (
      <div class="inner_select">
        {name && showLabel && <span class="scence_ctr_span_title">{name}</span>}
        <el-select onChange={change} value={value} class="input_set"
          collapse-tags={collapseTags !== undefined} multiple={multiple !== undefined}>
          {enumValues.map(el => <el-option key={el.Value} label={el.Name} value={el.Value} />)}
        </el-select>
      </div>

    )
  }
}
</script>

<style lang="scss" scoped>
@import "~@/components/button/comps-button.scss";
.inner_select{
  display: flex;
  flex-direction: row;
  align-items: baseline
}
</style>
